import { render, staticRenderFns } from "./video.edit.vue?vue&type=template&id=93f8e790&scoped=true"
import script from "./video.edit.vue?vue&type=script&lang=js"
export * from "./video.edit.vue?vue&type=script&lang=js"
import style0 from "./video.edit.vue?vue&type=style&index=0&id=93f8e790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f8e790",
  null
  
)

export default component.exports